'use client'

import cx from 'classnames'
import dynamic from 'next/dynamic'
import { FC } from 'react'

import spMv1 from '@/assets/images/about/mv_1-sp.jpg'
import Mv1 from '@/assets/images/about/mv_1.jpg'
import spMv2 from '@/assets/images/about/mv_2-sp.jpg'
import Mv2 from '@/assets/images/about/mv_2.jpg'
import '@/components/About/Molecules/FirstView/FirstView.scss'
import UParallax from '@/components/Common/UParallax'
import Picture from '@/components/Image/Picture'

const FirstViewLogic = dynamic(() => import('@/components/About/Molecules/FirstView/FirstViewLogic'), {
  ssr: true,
})

const FirstView: FC = () => {
  return (
    <>
      <section className={''}>
        <UParallax distance={25} isFv={true}>
          <div className={'p-about-main'}>
            <ul className="p-about-main__mv">
              <li className="p-about-main__mv-item">
                <div className="p-about-main__mv-image">
                  <Picture
                    src={Mv1.src}
                    width={Mv1.width}
                    height={Mv1.height}
                    spSrc={spMv1.src}
                    spWidth={spMv1.width}
                    spHeight={spMv1.height}
                    alt={'science'}
                  />
                </div>
              </li>
              <li className="p-about-main__mv-item">
                <div className="p-about-main__mv-image">
                  <Picture
                    src={Mv2.src}
                    width={Mv2.width}
                    height={Mv2.height}
                    spSrc={spMv2.src}
                    spWidth={spMv2.width}
                    spHeight={spMv2.height}
                    alt={'fermentation'}
                  />
                </div>
              </li>
            </ul>
            <FirstViewLogic>
              {(isShow) => {
                return (
                  <div className="p-about-main__title">
                    <h2 className="p-about-main__title-ja u-font-yu-min">
                      <span
                        className={cx('char', {
                          'char--show': isShow,
                        })}
                      >
                        発
                      </span>
                      <span
                        className={cx('char', {
                          'char--show': isShow,
                        })}
                      >
                        酵
                      </span>
                      <span
                        className={cx('char', {
                          'char--show': isShow,
                        })}
                      >
                        と
                      </span>
                      <span
                        className={cx('char', {
                          'char--show': isShow,
                        })}
                      >
                        科
                      </span>
                      <span
                        className={cx('char', {
                          'char--show': isShow,
                        })}
                      >
                        学
                      </span>
                    </h2>
                    <p
                      className={cx('p-about-main__title-en', {
                        'p-about-main__title-en--show': isShow,
                      })}
                    >
                      Fermentation & Science
                    </p>
                  </div>
                )
              }}
            </FirstViewLogic>
          </div>
        </UParallax>
      </section>
    </>
  )
}

export default FirstView
